<template>
  <div class="geodesia-lab">
    <b-row>
      <b-col cols="4">
        <b-card class="">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <h5 class="mb-0">
              ربط ملف JXL بمشروع
            </h5>
            <b-button
              variant="outline-secondary"
              size="sm"
              :disabled="assigningJxl || assigningCoordinates || unAssigningJxl"
              @click="resetAllForm"
            >
              <feather-icon
                icon="RefreshCwIcon"
                size="14"
                class="mr-1"
              />
              إعادة تعيين
            </b-button>
          </div>

          <!-- Search Project by Surveying Code -->
          <b-form-group>
            <div class="d-flex">
              <b-form-input
                v-model="searchSurveyingCode"
                placeholder="الكود المساحي للانتقال إلى المشروع على الخريطة"
                @keyup.enter="navigateToProjectByCode"
                @input="clearSearchMessages"
              />
              <b-button
                variant="info"
                :disabled="!searchSurveyingCode || searchingProject"
                @click="navigateToProjectByCode"
              >
                <b-spinner
                  v-if="searchingProject"
                  small
                />
                <feather-icon
                  v-else
                  icon="SearchIcon"
                  size="14"
                />

              </b-button>
            </div>
            <b-alert
              v-if="searchProjectError"
              variant="danger"
              show
              class="mb-0"
            >
              {{ searchProjectError }}
            </b-alert>
          </b-form-group>

          <b-form-group label="أكواد الرفع المساحي للمشاريع">
            <b-form-textarea
              v-model="assignSurveyCodingsText"
              placeholder="أدخل أكواد الرفع المساحي (واحد في كل سطر أو مفصولة بفواصل)"
              rows="2"
              @input="parseSurveyCodings"
            />
            <small class="text-muted">يمكنك إدخال عدة أكواد، واحد في كل سطر أو مفصولة بفواصل</small>
            <!-- <div v-if="assignSurveyCodings.length > 0" class="">
              <small class="text-success">عدد المشاريع المحددة: {{ assignSurveyCodings.length }}</small>
              <div class="">
                <b-badge
                  v-for="(code, index) in assignSurveyCodings"
                  :key="index"
                  variant="primary"
                  class="mr-1 mb-1"
                >
                  {{ code }}
                </b-badge>
              </div>
            </div> -->
          </b-form-group>

          <b-form-group label="معرف إحداثي JXL">
            <b-form-input
              v-model.number="assignJxlCoordinateId"
              type="number"
              placeholder="أدخل معرف إحداثي JXL"
            />
            <small class="text-muted">يمكنك الحصول على المعرف من النقاط على الخريطة</small>
          </b-form-group>
          <div class="d-flex gab-2">

          <b-button
            variant="primary"
            block
            :disabled="assignSurveyCodings.length === 0 || (selectedCoordinateIds.length === 0 && !assignJxlCoordinateId) || assigningJxl || unAssigningJxl"
            @click="handleAssignJxl"
          >
            <b-spinner
              v-if="assigningJxl"
              small
              class="mr-1"
            />
            {{ assigningJxl ? 'جاري الربط...' : `ربط` }}
          </b-button>
          <b-button 
            class="ml-1"
            variant="danger"
            block
            :disabled="!assignSurveyCodingsText"
            @click="handleUnAssignJxl"
          >
            <b-spinner
              v-if="unAssigningJxl"
              small
              class="mr-1"
            />
            {{ unAssigningJxl ? 'جاري الإلغاء...' : 'إلغاء الربط' }}
          </b-button>
          </div>


          <b-alert
            v-if="assignJxlError"
            variant="danger"
            show
            class="mt-3"
          >
            {{ assignJxlError }}
          </b-alert>

          <div
            v-if="assignJxlResult"
            class="mt-3"
          >
            <b-alert
              variant="success"
              show
            >

              <!-- Projects Tabs -->
              <div
                v-if="assignJxlResult.related_projects && assignJxlResult.related_projects.length > 0"
                class="mt-3"
              >
                <b-tabs
                  v-model="activeTabIndex"
                  @input="onTabChange"
                >
                  <b-tab
                    v-for="(project, index) in assignJxlResult.related_projects"
                    :key="project.id || index"
                    :title="project.survey_coding || `مشروع ${index + 1}`"
                  >
                    <div
                      v-if="loadingCoordinates"
                      class="text-center p-3"
                    >
                      <b-spinner small />
                      <small class="ml-2">جاري تحميل الإحداثيات...</small>
                    </div>
                    <div
                      v-else
                      class="max-height-200 overflow-auto border rounded p-2"
                    >
                      <div class="d-flex flex-wrap">
                        <b-form-checkbox
                          v-for="(point, pointIndex) in assignJxlResult.jxl_points"
                          :key="point.id || pointIndex"
                          v-model="selectedCoordinateIds"
                          :value="point.id"
                          class="mb-2 mr-3"
                        >
                          {{ point.point_name }}
                        </b-form-checkbox>
                      </div>
                    </div>
                    <div class="mt-3">
                      <b-button
                        variant="success"
                        size="sm"
                        :disabled="selectedCoordinateIds.length === 0 || assigningCoordinates || unAssigningJxl"
                        @click="handleAssignCoordinatesToProject(project.id)"
                      >
                        <b-spinner
                          v-if="assigningCoordinates"
                          small
                          class="mr-1"
                        />
                        {{ assigningCoordinates ? 'جاري الربط...' : `ربط ${selectedCoordinateIds.length} إحداثي بهذا المشروع` }}
                      </b-button>
                      <small
                        v-if="selectedCoordinateIds.length > 0"
                        class="ml-2 text-muted"
                      >
                        تم اختيار {{ selectedCoordinateIds.length }} إحداثي
                      </small>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>

            </b-alert>
          </div>
        </b-card>
      </b-col>
      <b-col cols="8">
        <div class="map-container-wrapper mb-1">
          <div
            v-if="mapLoading"
            class="loading-overlay"
          >
            <div class="spinner" />
            <p class="text-center mt-2">
              جاري تحميل الخريطة...
            </p>
          </div>
          <div
            v-if="loading && !mapLoading"
            class="loading-overlay"
          >
            <div class="spinner" />
            <p class="text-center mt-2">
              جاري تحميل البيانات...
            </p>
          </div>
          <div
            ref="esriView"
            class="map-view"
          />
        </div>

        <b-card v-if="error">
          <b-alert
            variant="danger"
            show
          >
            <strong>خطأ:</strong> {{ error }}
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { loadArcgisModules } from '@/utils/arcgisLoader'
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BSpinner,
  BAlert,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BBadge,
  BTabs,
  BTab,
} from 'bootstrap-vue'
import MapLibrary from '@/api/MapLibrary/MapLibraries'
import geodesiaApi from '@/api/geodesia/geodesia'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import {
  GEODESIA_LAYER_SOURCE,
  GEODESIA_LAYER_TRUNCATED_MESSAGE,
  GEODESIA_MAP_LAYER_KEYS,
  createGeodesiaLayerCancelSource,
  getGeodesiaLayerFeatures,
  hexColorToRgb,
  isGeodesiaLayerRequestCanceled,
  isGeodesiaLayerTruncated,
  unwrapGeodesiaLayerPayload,
} from '@/utils/geodesiaMapLayers'

const mapLibraryApi = new MapLibrary()

export default {
  name: 'GeodesiaLab',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BBadge,
    BTabs,
    BTab,
    FeatherIcon,
  },
  data() {
    return {
      map: null,
      view: null,
      projectsLayer: null,
      mapLibrariesLayer: null,
      fixedPointsLayer: null,
      vrsCoordinatesLayer: null,
      jxlCoordinatesLayer: null,
      jxlRw5CoordinatesLayer: null,
      jxlRawCoordinatesLayer: null,
      jxlPolygonsLayer: null,
      jxlBaselineLinesLayer: null,
      userLocationLayer: null,
      sketchLayer: null,
      sketch: null,
      arcgisModules: null,
      mapLoading: false,
      loading: false,
      locationLoading: false,
      error: null,
      chunkSize: 100000,
      dataStats: {
        projects: 0,
        mapLibraries: 0,
        fixedPoints: 0,
        vrsCoordinates: 0,
        jxlCoordinates: 0,
        jxlRw5Coordinates: 0,
        jxlRawCoordinates: 0,
        jxlPolygons: 0,
        jxlBaselineLines: 0,
      },
      jxlData: {
        points: [],
        rw5Points: [],
        rawPoints: [],
        polygons: [],
        baselineLines: [],
      },
      currentPolygonGraphic: null,
      debugInfo: null,
      userLocationObtained: false,
      defaultCenter: {
        latitude: 30.0444, // Cairo, Egypt
        longitude: 31.2357,
      },
      homeButton: null,
      layerVisibility: {
        projects: true,
        mapLibraries: false,
        fixedPoints: false,
        vrsCoordinates: false,
        jxlCoordinates: true,
        jxlRw5Coordinates: false,
        jxlRawCoordinates: false,
        jxlPolygons: false,
        jxlBaselineLines: false,
        userLocation: true,
      },
      geodesiaLayerCancels: {},
      geodesiaLayerLoaded: {},
      geodesiaLayerLoading: {},
      assignSurveyCodingsText: '',
      assignSurveyCodings: [],
      assignJxlCoordinateId: null,
      selectedCoordinateIds: [],
      assigningJxl: false,
      unAssigningJxl: false,
      assigningCoordinates: false,
      assignJxlError: null,
      assignJxlResult: null,
      activeTabIndex: 0,
      loadingCoordinates: false,
      searchSurveyingCode: '',
      searchingProject: false,
      searchProjectError: null,
      searchProjectSuccess: null,
    }
  },
  mounted() {
    this.initMap()
  },
  beforeDestroy() {
    this.cancelAllGeodesiaLayerRequests()
    if (this.view) {
      this.view.destroy()
    }
  },
  methods: {
    async initMap() {
      this.mapLoading = true
      try {
        const modules = await loadArcgisModules(
          [
            'esri/Map',
            'esri/views/MapView',
            'esri/layers/GraphicsLayer',
            'esri/Graphic',
            'esri/geometry/Point',
            'esri/geometry/Polygon',
            'esri/geometry/Polyline',
            'esri/symbols/SimpleMarkerSymbol',
            'esri/symbols/SimpleFillSymbol',
            'esri/symbols/SimpleLineSymbol',
            'esri/symbols/PictureMarkerSymbol',
            'esri/widgets/Search',
            'esri/widgets/LayerList',
            'esri/widgets/Sketch',
            'esri/widgets/Popup',
            'esri/geometry/Extent',
            'esri/geometry/geometryEngine',
          ],
        )

        this.arcgisModules = {
          Map: modules[0],
          MapView: modules[1],
          GraphicsLayer: modules[2],
          Graphic: modules[3],
          Point: modules[4],
          Polygon: modules[5],
          Polyline: modules[6],
          SimpleMarkerSymbol: modules[7],
          SimpleFillSymbol: modules[8],
          SimpleLineSymbol: modules[9],
          PictureMarkerSymbol: modules[10],
          Search: modules[11],
          LayerList: modules[12],
          Sketch: modules[13],
          Popup: modules[14],
          Extent: modules[15],
          geometryEngine: modules[16],
        }

        // Create separate layers for each data type
        this.projectsLayer = new this.arcgisModules.GraphicsLayer({
          title: 'المشاريع',
          visible: true,
        })
        this.mapLibrariesLayer = new this.arcgisModules.GraphicsLayer({
          title: 'مكتبات الخرائط',
          visible: false,
        })
        this.fixedPointsLayer = new this.arcgisModules.GraphicsLayer({
          title: 'النقاط الثابتة',
          visible: false,
        })
        this.vrsCoordinatesLayer = new this.arcgisModules.GraphicsLayer({
          title: 'إحداثيات VRS',
          visible: this.layerVisibility.vrsCoordinates,
        })
        this.jxlCoordinatesLayer = new this.arcgisModules.GraphicsLayer({
          title: 'إحداثيات JXL',
          visible: this.layerVisibility.jxlCoordinates,
        })
        this.jxlRw5CoordinatesLayer = new this.arcgisModules.GraphicsLayer({
          title: 'إحداثيات RW5',
          visible: this.layerVisibility.jxlRw5Coordinates,
        })
        this.jxlRawCoordinatesLayer = new this.arcgisModules.GraphicsLayer({
          title: 'إحداثيات RAW',
          visible: this.layerVisibility.jxlRawCoordinates,
        })
        this.jxlPolygonsLayer = new this.arcgisModules.GraphicsLayer({
          title: 'مضلعات JXL',
          visible: this.layerVisibility.jxlPolygons,
        })
        this.jxlBaselineLinesLayer = new this.arcgisModules.GraphicsLayer({
          title: 'خطوط الأساس (JXL)',
          visible: this.layerVisibility.jxlBaselineLines,
        })
        this.userLocationLayer = new this.arcgisModules.GraphicsLayer({
          title: 'موقعي الحالي',
          visible: true,
        })

        this.map = new this.arcgisModules.Map({
          basemap: 'hybrid',
          layers: [
            this.projectsLayer,
            this.mapLibrariesLayer,
            this.fixedPointsLayer,
            this.vrsCoordinatesLayer,
            this.jxlPolygonsLayer,
            this.jxlBaselineLinesLayer,
            this.jxlRawCoordinatesLayer,
            this.jxlRw5CoordinatesLayer,
            this.jxlCoordinatesLayer,
            this.userLocationLayer,
          ],
        })

        // Try to get user location first to center the map
        let mapCenter = [this.defaultCenter.longitude, this.defaultCenter.latitude]
        let mapZoom = 15

        try {
          const userLocation = await this.getUserCurrentLocation()
          mapCenter = [userLocation.longitude, userLocation.latitude]
          mapZoom = 15 // Zoom in more when showing user location
          this.userLocationObtained = true
          console.log('Using user location as map center:', mapCenter)
        } catch (error) {
          this.userLocationObtained = false
          console.warn('Could not get user location, using default center:', error)
        }

        this.view = new this.arcgisModules.MapView({
          container: this.$refs.esriView,
          map: this.map,
          center: mapCenter,
          zoom: mapZoom,
          popupEnabled: false,
        })

        // Wait for view to be ready
        await this.view.when()

        // Create and configure popup widget (required for view.openPopup() in 4.27+)
        if (this.arcgisModules.Popup) {
          const popup = new this.arcgisModules.Popup({
            dockEnabled: false,
            defaultPopupTemplateEnabled: true,
          })
          this.view.popup = popup
        }

        // Add search widget
        this.addSearchWidget()

        // Add Sketch widget with settings panel (includes snapping layers)
        this.addSketchWidget()
        this.bindGeodesiaLayerVisibilityWatchers()

        // Add home (current location) button next to zoom controls
        this.addHomeButtonToView()

        // Bind click events after view is ready
        this.bindMapClickEvents()

        // Bind hover events for JXL point tooltips
        this.bindJxlHoverTooltip()

        // Get user location automatically and add marker
        this.addUserLocation().catch(err => {
          console.warn('Could not add user location marker:', err)
        })

        // Load map data automatically
        await this.loadMapData()
      } catch (error) {
        console.error('Failed to initialize Esri map', error)
        this.error = 'فشل في تحميل الخريطة'
      } finally {
        this.mapLoading = false
      }
    },
    bindGeodesiaLayerVisibilityWatchers() {
      GEODESIA_MAP_LAYER_KEYS.forEach(layerKey => {
        const layer = this.getGeodesiaGraphicsLayer(layerKey)
        if (!layer?.watch) return
        layer.watch('visible', visible => {
          this.layerVisibility[layerKey] = visible
          if (visible) this.loadGeodesiaMapLayer(layerKey)
          else this.cancelGeodesiaLayerRequest(layerKey)
        })
      })
    },
    toggleLayer(layerName) {
      if (!this.map) return

      const layerMap = {
        projects: this.projectsLayer,
        mapLibraries: this.mapLibrariesLayer,
        fixedPoints: this.fixedPointsLayer,
        vrsCoordinates: this.vrsCoordinatesLayer,
        jxlCoordinates: this.jxlCoordinatesLayer,
        jxlRw5Coordinates: this.jxlRw5CoordinatesLayer,
        jxlRawCoordinates: this.jxlRawCoordinatesLayer,
        jxlPolygons: this.jxlPolygonsLayer,
        jxlBaselineLines: this.jxlBaselineLinesLayer,
        userLocation: this.userLocationLayer,
      }

      const layer = layerMap[layerName]
      if (layer) {
        layer.visible = this.layerVisibility[layerName]
      }

      if (GEODESIA_MAP_LAYER_KEYS.includes(layerName)) {
        if (this.layerVisibility[layerName]) {
          this.loadGeodesiaMapLayer(layerName)
        } else {
          this.cancelGeodesiaLayerRequest(layerName)
        }
      }
    },
    updateLayerVisibility() {
      if (!this.map) return

      if (this.projectsLayer) {
        this.projectsLayer.visible = this.layerVisibility.projects
      }
      if (this.mapLibrariesLayer) {
        this.mapLibrariesLayer.visible = this.layerVisibility.mapLibraries
      }
      if (this.fixedPointsLayer) {
        this.fixedPointsLayer.visible = this.layerVisibility.fixedPoints
      }
      if (this.vrsCoordinatesLayer) {
        this.vrsCoordinatesLayer.visible = this.layerVisibility.vrsCoordinates
      }
      if (this.jxlCoordinatesLayer) {
        this.jxlCoordinatesLayer.visible = this.layerVisibility.jxlCoordinates
      }
      if (this.jxlRw5CoordinatesLayer) {
        this.jxlRw5CoordinatesLayer.visible = this.layerVisibility.jxlRw5Coordinates
      }
      if (this.jxlRawCoordinatesLayer) {
        this.jxlRawCoordinatesLayer.visible = this.layerVisibility.jxlRawCoordinates
      }
      if (this.jxlPolygonsLayer) {
        this.jxlPolygonsLayer.visible = this.layerVisibility.jxlPolygons
      }
      if (this.jxlBaselineLinesLayer) {
        this.jxlBaselineLinesLayer.visible = this.layerVisibility.jxlBaselineLines
      }
      if (this.userLocationLayer) {
        this.userLocationLayer.visible = this.layerVisibility.userLocation
      }
    },
    addSearchWidget() {
      if (!this.view || !this.arcgisModules) return
      const search = new this.arcgisModules.Search({
        view: this.view,
        includeDefaultSources: true,
      })
      this.view.ui.add(search, 'top-right')
    },
    addSketchWidget() {
      if (!this.view || !this.arcgisModules || !this.projectsLayer) return

      // Create a graphics layer for sketch operations
      if (!this.sketchLayer) {
        this.sketchLayer = new this.arcgisModules.GraphicsLayer({
          title: 'Sketch Layer',
        })
        this.map.add(this.sketchLayer)
      }

      // Create feature sources with layer mapping
      const featureSources = [
        {
          layer: this.userLocationLayer,
          enabled: true,
        },
        {
          layer: this.projectsLayer,
          enabled: true,
        },
        {
          layer: this.mapLibrariesLayer,
          enabled: false,
        },
        {
          layer: this.fixedPointsLayer,
          enabled: false,
        },
        {
          layer: this.vrsCoordinatesLayer,
          enabled: this.layerVisibility.vrsCoordinates,
        },
        {
          layer: this.jxlCoordinatesLayer,
          enabled: this.layerVisibility.jxlCoordinates,
        },
        {
          layer: this.jxlRw5CoordinatesLayer,
          enabled: this.layerVisibility.jxlRw5Coordinates,
        },
        {
          layer: this.jxlRawCoordinatesLayer,
          enabled: this.layerVisibility.jxlRawCoordinates,
        },
        {
          layer: this.jxlPolygonsLayer,
          enabled: this.layerVisibility.jxlPolygons,
        },
        {
          layer: this.jxlBaselineLinesLayer,
          enabled: this.layerVisibility.jxlBaselineLines,
        },
      ]

      // Create layer mapping for easy lookup
      const layerMap = {
        [this.userLocationLayer.id]: this.userLocationLayer,
        [this.projectsLayer.id]: this.projectsLayer,
        [this.mapLibrariesLayer.id]: this.mapLibrariesLayer,
        [this.fixedPointsLayer.id]: this.fixedPointsLayer,
        [this.vrsCoordinatesLayer.id]: this.vrsCoordinatesLayer,
        [this.jxlCoordinatesLayer.id]: this.jxlCoordinatesLayer,
        [this.jxlRw5CoordinatesLayer.id]: this.jxlRw5CoordinatesLayer,
        [this.jxlRawCoordinatesLayer.id]: this.jxlRawCoordinatesLayer,
        [this.jxlPolygonsLayer.id]: this.jxlPolygonsLayer,
        [this.jxlBaselineLinesLayer.id]: this.jxlBaselineLinesLayer,
      }

      const sketch = new this.arcgisModules.Sketch({
        view: this.view,
        layer: this.sketchLayer,
        // Configure snapping options to use map layers
        snappingOptions: {
          enabled: true,
          selfEnabled: true,
          featureEnabled: true,
          featureSources,
        },
        // Enable tooltips and geometry guides
        tooltipOptions: {
          enabled: true,
        },
        // Enable geometry guides
        defaultUpdateOptions: {
          tooltipOptions: {
            enabled: true,
          },
        },
      })

      // Function to sync layer visibility with snapping enabled state
      const syncLayerVisibility = () => {
        const { snappingOptions } = sketch.viewModel
        if (snappingOptions && snappingOptions.featureSources) {
          snappingOptions.featureSources.forEach(source => {
            if (source.layer && layerMap[source.layer.id]) {
              const layer = layerMap[source.layer.id]
              // Sync layer visibility with snapping enabled state
              layer.visible = source.enabled !== false
            }
          })
        }
      }

      // Watch each feature source's enabled property
      featureSources.forEach(source => {
        if (source.watch) {
          source.watch('enabled', enabled => {
            if (source.layer && layerMap[source.layer.id]) {
              const layer = layerMap[source.layer.id]
              layer.visible = enabled !== false
            }
          })
        }
      })

      // Watch for changes in snapping options
      if (sketch.viewModel.snappingOptions) {
        // Watch the featureSources array
        if (sketch.viewModel.snappingOptions.featureSources) {
          sketch.viewModel.snappingOptions.featureSources.forEach(source => {
            if (source.watch) {
              source.watch('enabled', () => {
                syncLayerVisibility()
              })
            }
          })
        }

        // Watch the featureSources property itself
        sketch.viewModel.snappingOptions.watch('featureSources', () => {
          syncLayerVisibility()
        })
      }

      // Also watch the viewModel's snappingOptions property
      sketch.viewModel.watch('snappingOptions', () => {
        syncLayerVisibility()
      })

      // Set up interval to check for changes (fallback method)
      // This ensures we catch changes even if watchers don't fire
      const visibilityCheckInterval = setInterval(() => {
        syncLayerVisibility()
      }, 300)

      // Clean up interval when component is destroyed
      this.$once('hook:beforeDestroy', () => {
        if (visibilityCheckInterval) {
          clearInterval(visibilityCheckInterval)
        }
      })

      // Add sketch widget to the view
      this.view.ui.add(sketch, 'top-right')
      this.sketch = sketch
    },
    addHomeButtonToView() {
      if (!this.view) return

      const button = document.createElement('button')
      button.className = 'esri-widget--button esri-widget home-location-button'
      button.title = 'الذهاب إلى موقعي الحالي'

      button.addEventListener('click', () => {
        this.addUserLocation()
      })

      // Keep reference so we can show loader state
      this.homeButton = button
      this.setHomeButtonLoading(this.locationLoading)

      // Place it with the zoom controls (top-left)
      this.view.ui.add(button, 'top-left')
    },
    bindMapClickEvents() {
      if (!this.view) return
      this.view.on('click', async event => {
        const hit = await this.view.hitTest(event, {
          include: [
            this.projectsLayer,
            this.mapLibrariesLayer,
            this.fixedPointsLayer,
            this.vrsCoordinatesLayer,
            this.jxlCoordinatesLayer,
            this.jxlRw5CoordinatesLayer,
            this.jxlRawCoordinatesLayer,
            this.jxlPolygonsLayer,
            this.jxlBaselineLinesLayer,
            this.userLocationLayer,
          ],
        })

        if (hit && hit.results && hit.results.length > 0) {
          const result = hit.results[0]
          const { graphic } = result
          const { attributes } = graphic

          // Handle JXL point click to show polygon and enhanced popup
          if (this.isJxlFamilyPointLayer(graphic.layer) && attributes && attributes.jxl_file_id) {
            // Auto-fill coordinate ID in the assign form
            if (attributes.id) {
              this.assignJxlCoordinateId = attributes.id
            }

            // Show the polygon for this point
            this.showJxlPolygon(attributes.jxl_file_id)

            // Enhance popup content to include polygon info
            const enhancedPopupContent = this.buildJxlPointPopupWithPolygon(attributes)

            // Use the new API: view.openPopup() with enhanced content
            this.view.openPopup({
              location: result.mapPoint,
              title: attributes.point_name || `JXL Point ${attributes.id || ''}`,
              content: enhancedPopupContent,
              // updateLocationEnabled: true,
              popupEnabled: true,
            })
          } else {
            // Use the new API: view.openPopup() instead of view.popup.open()
            // Set location to the clicked point so popup appears at the item location
            this.view.openPopup({
              location: result.mapPoint,
              features: [result.graphic],
              // updateLocationEnabled: true, // Allow popup to update location when map moves
              popupEnabled: true,
            })
          }
        } else {
          // Use the new API: view.closePopup() instead of view.popup.close()
          this.view.closePopup()
        }
      })
    },
    bindJxlHoverTooltip() {
      if (!this.view || !this.jxlCoordinatesLayer || !this.jxlRw5CoordinatesLayer || !this.jxlRawCoordinatesLayer) return

      let hoveredGraphic = null
      let tooltipTimeout = null

      // Helper function to check if popup has content (click popups have content, hover tooltips don't)
      const hasPopupContent = () => {
        if (!this.view || !this.view.popup || !this.view.popup.visible) return false

        // Check if popup has features (click popups usually have features)
        const features = this.view.popup.selectedFeature || this.view.popup.features
        if (features && (Array.isArray(features) ? features.length > 0 : features)) {
          return true
        }

        // Check content (could be string or DOM element)
        const popupContent = this.view.popup.content
        if (typeof popupContent === 'string') {
          return popupContent.trim() !== ''
        }
        return popupContent !== null && popupContent !== undefined && popupContent !== ''
      }

      this.view.on('pointer-move', async event => {
        // Don't interfere with click popups (they have content)
        if (hasPopupContent()) {
          return
        }

        // Clear any existing timeout
        if (tooltipTimeout) {
          clearTimeout(tooltipTimeout)
          tooltipTimeout = null
        }

        try {
          const hit = await this.view.hitTest(event, {
            include: [
              this.jxlCoordinatesLayer,
              this.jxlRw5CoordinatesLayer,
              this.jxlRawCoordinatesLayer,
            ],
          })

          if (hit && hit.results && hit.results.length > 0) {
            const result = hit.results[0]
            const { graphic } = result

            // Check if it's a JXL / RW5 / RAW coordinate point
            if (graphic && this.isJxlFamilyPointLayer(graphic.layer) && graphic.attributes) {
              const { attributes } = graphic
              const pointName = `${attributes.point_name} - ${attributes.id}` || `JXL Point ${attributes.id || ''}`

              // Only show tooltip if it's a different graphic or first time
              if (hoveredGraphic !== graphic) {
                hoveredGraphic = graphic

                // Show tooltip using popup with just the point name
                this.view.openPopup({
                  location: result.mapPoint,
                  title: pointName,
                  content: '',
                  popupEnabled: true,
                })
              }
              return
            }
          }

          // Hide tooltip if not over JXL coordinate (only if popup doesn't have content)
          if (hoveredGraphic && !hasPopupContent()) {
            hoveredGraphic = null
            this.view.closePopup()
          }
        } catch (error) {
          // Silently handle errors
          if (hoveredGraphic && !hasPopupContent()) {
            hoveredGraphic = null
            this.view.closePopup()
          }
        }
      })

      // Hide tooltip when pointer leaves the view (only if popup doesn't have content)
      this.view.on('pointer-leave', () => {
        if (hoveredGraphic && !hasPopupContent()) {
          hoveredGraphic = null
          this.view.closePopup()
        }
      })
    },
    async loadMapData() {
      if (this.loading) return
      this.loading = true
      this.error = null
      this.dataStats = {
        projects: 0,
        mapLibraries: 0,
        fixedPoints: 0,
        vrsCoordinates: 0,
        jxlCoordinates: 0,
        jxlRw5Coordinates: 0,
        jxlRawCoordinates: 0,
        jxlPolygons: 0,
        jxlBaselineLines: 0,
      }

      try {
        console.log('Loading map data with chunk_size:', this.chunkSize)
        const response = await mapLibraryApi.getAllMapData({
          chunk_size: this.chunkSize,
        })

        console.log('Map data response:', response)
        console.log('Response.data:', response.data)
        console.log('Response keys:', Object.keys(response))
        console.log('Has response.data.projects?', response.data && response.data.projects)
        console.log('Has response.projects?', response.projects)

        // Handle both response.data and direct response structure
        // Check if data is in response.data first (axios default), then check response directly
        let data = {}
        if (response.data && (response.data.projects || response.data.map_libraries || response.data.fixed_points)) {
          data = response.data
          console.log('Using response.data')
        } else if (response.projects || response.map_libraries || response.fixed_points) {
          data = response
          console.log('Using response directly')
        } else {
          data = {}
          console.warn('Could not find data in response')
        }

        const projects = data.projects || []
        const mapLibraries = data.map_libraries || []
        const fixedPoints = data.fixed_points || []

        console.log(`Received ${projects.length} projects, ${mapLibraries.length} map libraries, ${fixedPoints.length} fixed points`)
        console.log('Sample project:', projects[0])
        console.log('Sample map library:', mapLibraries[0])
        console.log('Sample fixed point:', fixedPoints[0])

        // Update stats
        this.dataStats = {
          projects: projects.length,
          mapLibraries: mapLibraries.length,
          fixedPoints: fixedPoints.length,
        }

        this.debugInfo = `تم استلام ${projects.length} مشروع، ${mapLibraries.length} مكتبة خرائط، ${fixedPoints.length} نقطة ثابتة`

        // Ensure view is ready
        if (!this.view) {
          console.error('View is not ready yet')
          return
        }

        // Ensure view is fully loaded
        await this.view.when()

        // Clear existing graphics
        if (this.projectsLayer) this.projectsLayer.removeAll()
        if (this.mapLibrariesLayer) this.mapLibrariesLayer.removeAll()
        if (this.fixedPointsLayer) this.fixedPointsLayer.removeAll()
        if (this.vrsCoordinatesLayer) this.vrsCoordinatesLayer.removeAll()
        if (this.jxlCoordinatesLayer) this.jxlCoordinatesLayer.removeAll()
        if (this.jxlRw5CoordinatesLayer) this.jxlRw5CoordinatesLayer.removeAll()
        if (this.jxlRawCoordinatesLayer) this.jxlRawCoordinatesLayer.removeAll()
        if (this.jxlPolygonsLayer) this.jxlPolygonsLayer.removeAll()
        if (this.jxlBaselineLinesLayer) this.jxlBaselineLinesLayer.removeAll()
        this.currentPolygonGraphic = null

        // Add projects
        if (projects.length > 0) {
          this.addProjectsToMap(projects)
        }

        // Add map libraries
        if (mapLibraries.length > 0) {
          this.addMapLibrariesToMap(mapLibraries)
        }

        // Add fixed points
        if (fixedPoints.length > 0) {
          this.addFixedPointsToMap(fixedPoints)
        }

        // Load visible Geodesia layers independently
        await this.loadVisibleGeodesiaLayers()

        // Wait a bit for graphics to render
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 500))

        // Zoom to extent if we have data, but only if user location was not obtained
        // This preserves the user's location view when they grant permission
        if (this.view && (projects.length > 0 || mapLibraries.length > 0 || fixedPoints.length > 0 || this.dataStats.vrsCoordinates > 0 || this.dataStats.jxlCoordinates > 0 || this.dataStats.jxlBaselineLines > 0)) {
          if (!this.userLocationObtained) {
            // Only zoom to extent if we don't have user location
            await this.zoomToExtent()
          } else {
            console.log('Preserving user location view - skipping zoom to extent')
          }
        } else {
          console.log('No data to display on map')
        }
      } catch (error) {
        console.error('Error loading map data:', error)
        if (error.response && error.response.status === 401) {
          this.error = 'يرجى تسجيل الدخول'
        } else if (error.response && error.response.status === 403) {
          this.error = 'ليس لديك صلاحية لعرض هذه البيانات'
        } else {
          this.error = (error.response && error.response.data && error.response.data.message) || error.message || 'حدث خطأ أثناء تحميل البيانات'
        }
      } finally {
        this.loading = false
      }
    },
    addProjectsToMap(projects) {
      if (!this.projectsLayer || !this.arcgisModules || !projects.length) {
        console.log('Cannot add projects - missing layer or modules or no projects')
        return
      }

      const {
        Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol,
      } = this.arcgisModules
      let addedCount = 0

      projects.forEach(project => {
        try {
          // Extract coordinates from geometry
          const coordinates = project.geometry && project.geometry.coordinates
          if (!coordinates || !coordinates[0] || !coordinates[0].length) {
            console.warn('Invalid project geometry:', project)
            return
          }

          // Ensure coordinates are in [lng, lat] format
          const rings = coordinates[0].map(coord => {
            // Handle both [lng, lat] and [lat, lng] formats
            if (Array.isArray(coord) && coord.length >= 2) {
              // If lat > 90 or lat < -90, it's likely swapped
              if (Math.abs(coord[0]) > 90 || Math.abs(coord[1]) > 90) {
                return [coord[1], coord[0]] // Swap if needed
              }
              return [coord[0], coord[1]]
            }
            return coord
          })

          // Create polygon geometry
          const polygon = new Polygon({
            rings,
            spatialReference: { wkid: 4326 },
          })

          // Create symbol with color from project attributes
          // Convert hex color to RGBA array format
          const colorHex = project.attributes.color || '#FF0000'
          const fillColor = this.hexToRgb(colorHex)
          const fillColorWithAlpha = [
            fillColor[0], // Red
            fillColor[1], // Green
            fillColor[2], // Blue
            0.5, // Alpha (transparency) - adjust this value as needed
          ]
          // Create a darker outline color from the fill color
          const outlineColor = [
            Math.max(0, fillColor[0] - 30), // Darker red
            Math.max(0, fillColor[1] - 30), // Darker green
            Math.max(0, fillColor[2] - 30), // Darker blue
          ]

          const symbol = new SimpleFillSymbol({
            color: fillColorWithAlpha, // RGBA array format
            outline: new SimpleLineSymbol({
              color: outlineColor,
              width: 1,
            }),
          })

          // Build popup content
          const popupContent = this.buildProjectPopupContent(project.attributes)

          // Create graphic
          const graphic = new Graphic({
            geometry: polygon,
            symbol,
            attributes: project.attributes,
            popupTemplate: {
              title: project.attributes.name || 'مشروع',
              content: popupContent,
            },
          })

          this.projectsLayer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding project to map:', error, project)
        }
      })

      console.log(`Added ${addedCount} projects to map out of ${projects.length}`)
    },
    async updateProjectsFromMapData() {
      if (!this.projectsLayer || !this.arcgisModules) {
        return
      }

      try {
        // Fetch updated map data from API
        const response = await mapLibraryApi.getAllMapData({
          chunk_size: this.chunkSize,
        })

        // Extract projects from response.data.projects
        let projects = []
        if (response && response.data && response.data.projects) {
          projects = response.data.projects
        } else if (response && response.projects) {
          projects = response.projects
        }

        if (!projects || projects.length === 0) {
          console.log('No projects found in map data response')
          return
        }

        const {
          Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol,
        } = this.arcgisModules
        let updatedCount = 0

        projects.forEach(project => {
          try {
            const projectId = project.attributes && project.attributes.id
            if (!projectId) {
              console.warn('Project missing ID:', project)
              return
            }

            // Find existing graphic by project ID
            const existingGraphics = this.projectsLayer.graphics.toArray()
            const existingGraphic = existingGraphics.find(g => g.attributes && g.attributes.id === projectId)

            if (!existingGraphic) {
              console.log(`Project ${projectId} not found on map, skipping update`)
              return
            }

            // Extract coordinates from geometry
            const coordinates = project.geometry && project.geometry.coordinates
            if (!coordinates || !coordinates[0] || !coordinates[0].length) {
              console.warn('Invalid project geometry for update:', project)
              return
            }

            // Ensure coordinates are in [lng, lat] format
            const rings = coordinates[0].map(coord => {
              if (Array.isArray(coord) && coord.length >= 2) {
                if (Math.abs(coord[0]) > 90 || Math.abs(coord[1]) > 90) {
                  return [coord[1], coord[0]] // Swap if needed
                }
                return [coord[0], coord[1]]
              }
              return coord
            })

            // Create updated polygon geometry
            const polygon = new Polygon({
              rings,
              spatialReference: { wkid: 4326 },
            })

            // Create updated symbol with color from project attributes
            const colorHex = project.attributes.color || '#666666'
            const fillColor = this.hexToRgb(colorHex)

            const outlineColor = [
              Math.max(0, fillColor[0] - 30),
              Math.max(0, fillColor[1] - 30),
              Math.max(0, fillColor[2] - 30),
            ]

            const symbol = new SimpleFillSymbol({
              color: fillColor,
              outline: new SimpleLineSymbol({
                color: outlineColor,
                width: 2,
              }),
            })

            // Build updated popup content
            const popupContent = this.buildProjectPopupContent(project.attributes)

            // Update the existing graphic
            existingGraphic.geometry = polygon
            existingGraphic.symbol = symbol
            existingGraphic.attributes = project.attributes
            existingGraphic.popupTemplate = {
              title: project.attributes.name || 'مشروع',
              content: popupContent,
            }

            updatedCount++
          } catch (error) {
            console.error('Error updating project on map:', error, project)
          }
        })

        console.log(`Updated ${updatedCount} project(s) on map`)
      } catch (error) {
        console.error('Error updating projects from API response:', error)
      }
    },
    addMapLibrariesToMap(mapLibraries) {
      if (!this.mapLibrariesLayer || !this.arcgisModules || !mapLibraries.length) {
        console.log('Cannot add map libraries - missing layer or modules or no libraries')
        return
      }

      const {
        Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol,
      } = this.arcgisModules
      let addedCount = 0

      mapLibraries.forEach(library => {
        try {
          // Use geometry_geojson if available, otherwise use geometry
          const geometryData = library.geometry_geojson && Object.keys(library.geometry_geojson).length > 0
            ? library.geometry_geojson
            : library.geometry

          if (!geometryData) {
            console.warn('Invalid map library geometry - no geometry data:', library)
            return
          }

          // Handle different geometry formats
          let coordinates = null

          if (geometryData.coordinates) {
            coordinates = geometryData.coordinates
          } else if (geometryData.rings) {
            // Already in ArcGIS format
            coordinates = [geometryData.rings]
          } else {
            console.warn('Invalid map library geometry - no coordinates or rings:', library)
            return
          }

          // Validate coordinates structure
          if (!Array.isArray(coordinates) || coordinates.length === 0) {
            console.warn('Invalid map library geometry - coordinates is not an array:', library)
            return
          }

          // Get the first ring (outer ring for polygon)
          const firstRing = coordinates[0]
          if (!Array.isArray(firstRing) || firstRing.length < 3) {
            console.warn('Invalid map library geometry - first ring is invalid:', library)
            return
          }

          // Convert coordinates to [lng, lat] format
          const rings = firstRing.map(coord => {
            if (!Array.isArray(coord) || coord.length < 2) {
              console.warn('Invalid coordinate in map library:', coord)
              return null
            }

            const lng = Number(coord[0])
            const lat = Number(coord[1])

            // Validate coordinates are numbers
            if (isNaN(lng) || isNaN(lat)) {
              console.warn('Invalid coordinate values (NaN):', coord)
              return null
            }

            // Check if coordinates are swapped (lat > 90 means it's likely longitude)
            if (Math.abs(lat) > 90) {
              // Likely swapped, but also check if lng is in valid lat range
              if (Math.abs(lng) <= 90) {
                return [lat, lng] // Swap
              }
            }

            return [lng, lat]
          }).filter(coord => coord !== null) // Remove invalid coordinates

          // Validate we have at least 3 points for a polygon
          if (rings.length < 3) {
            console.warn('Invalid map library geometry - not enough valid coordinates:', library)
            return
          }

          // Create polygon geometry
          const polygon = new Polygon({
            rings: [rings], // Wrap in array for rings
            spatialReference: { wkid: 4326 },
          })

          // Create symbol
          const symbol = new SimpleFillSymbol({
            color: [0, 0, 255, 0.3], // Blue with transparency
            outline: new SimpleLineSymbol({
              color: [0, 0, 255],
              width: 1,
            }),
          })

          // Build popup content
          const popupContent = this.buildMapLibraryPopupContent(library.attributes)

          // Create graphic
          const graphic = new Graphic({
            geometry: polygon,
            symbol,
            attributes: library.attributes,
            popupTemplate: {
              title: 'مكتبة خرائط',
              content: popupContent,
            },
          })

          this.mapLibrariesLayer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding map library to map:', error, library)
        }
      })

      console.log(`Added ${addedCount} map libraries to map out of ${mapLibraries.length}`)
    },
    addFixedPointsToMap(fixedPoints) {
      if (!this.fixedPointsLayer || !this.arcgisModules || !fixedPoints.length) {
        console.log('Cannot add fixed points - missing layer or modules or no points')
        return
      }

      const {
        Point, Graphic, SimpleMarkerSymbol, PictureMarkerSymbol,
      } = this.arcgisModules
      let addedCount = 0

      fixedPoints.forEach(point => {
        try {
          const coordinates = point.geometry && point.geometry.coordinates
          if (!coordinates || coordinates.length < 2) {
            console.warn('Invalid fixed point geometry:', point)
            return
          }

          let [longitude, latitude] = coordinates

          // Handle swapped coordinates
          if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) {
            [longitude, latitude] = [latitude, longitude]
          }

          if (!longitude || !latitude || isNaN(longitude) || isNaN(latitude)) {
            console.warn('Invalid coordinates for fixed point:', coordinates)
            return
          }

          // Create point geometry
          const pointGeometry = new Point({
            longitude,
            latitude,
            spatialReference: { wkid: 4326 },
          })

          // Use accuracy degree color if available
          let symbol
          const colorHex = point.attributes && point.attributes.accuracy_degree_color ? point.attributes.accuracy_degree_color : '#00ff00'
          const rgb = this.hexToRgb(colorHex)

          // Try to use custom pin icon, fallback to simple marker
          try {
            const pinSvg = this.createPinIcon(colorHex)
            symbol = new PictureMarkerSymbol({
              url: pinSvg,
              width: 32,
              height: 40,
              xoffset: 0,
              yoffset: 20,
            })
          } catch (error) {
            // Fallback to simple marker
            symbol = new SimpleMarkerSymbol({
              style: 'circle',
              color: rgb,
              size: 8,
              outline: {
                color: [255, 255, 255],
                width: 1,
              },
            })
          }

          // Build popup content
          const popupContent = this.buildFixedPointPopupContent(point.attributes)

          // Create graphic
          const graphic = new Graphic({
            geometry: pointGeometry,
            symbol,
            attributes: point.attributes,
            popupTemplate: {
              title: `نقطة ثابتة: ${point.attributes && point.attributes.code ? point.attributes.code : 'N/A'}`,
              content: popupContent,
            },
          })

          this.fixedPointsLayer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding fixed point to map:', error, point)
        }
      })

      console.log(`Added ${addedCount} fixed points to map out of ${fixedPoints.length}`)
    },
    async loadVrsCoordinates() {
      return this.loadGeodesiaMapLayer('vrsCoordinates')
    },
    addVrsCoordinatesToMap(points) {
      if (!this.vrsCoordinatesLayer || !this.arcgisModules || !points.length) {
        console.log('Cannot add VRS coordinates - missing layer or modules or no points')
        return
      }

      const { Point, Graphic, SimpleMarkerSymbol } = this.arcgisModules
      let addedCount = 0

      // Create marker symbol - orange color to match VrsCoordinatesMap.vue
      const markerSymbol = new SimpleMarkerSymbol({
        style: 'circle',
        color: [226, 119, 40, 0.8], // Orange color
        size: 8,
        outline: {
          color: [255, 255, 255, 0.8],
          width: 2,
        },
      })

      points.forEach(point => {
        try {
          const coordinates = point.geometry && point.geometry.coordinates
          if (!coordinates || coordinates.length < 2) {
            console.warn('Invalid VRS coordinate geometry:', point)
            return
          }

          const [longitude, latitude] = coordinates

          if (!longitude || !latitude || isNaN(longitude) || isNaN(latitude)) {
            console.warn('Invalid coordinates for VRS point:', coordinates)
            return
          }

          // Create point geometry
          const pointGeometry = new Point({
            longitude,
            latitude,
            spatialReference: { wkid: 4326 },
          })

          // Build popup content
          const attributes = point.attributes || {}
          const popupContent = this.buildVrsCoordinatePopupContent(attributes)

          // Create graphic
          const graphic = new Graphic({
            geometry: pointGeometry,
            symbol: markerSymbol,
            attributes,
            popupTemplate: {
              title: attributes.point_name || `VRS Point ${attributes.id || ''}`,
              content: popupContent,
            },
          })

          this.vrsCoordinatesLayer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding VRS coordinate to map:', error, point)
        }
      })

      console.log(`Added ${addedCount} VRS coordinates to map out of ${points.length}`)
    },
    buildVrsCoordinatePopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = ''
      if (attributes.id) {
        content += `<b>ID:</b> ${attributes.id}<br>`
      }
      if (attributes.point_name) {
        content += `<b>اسم النقطة:</b> ${attributes.point_name}<br>`
      }
      if (attributes.latitude !== undefined && attributes.latitude !== null) {
        content += `<b>خط العرض:</b> ${parseFloat(attributes.latitude).toFixed(8)}<br>`
      }
      if (attributes.longitude !== undefined && attributes.longitude !== null) {
        content += `<b>خط الطول:</b> ${parseFloat(attributes.longitude).toFixed(8)}<br>`
      }
      if (attributes.elevation !== undefined && attributes.elevation !== null) {
        content += `<b>الارتفاع:</b> ${attributes.elevation}m<br>`
      }
      if (attributes.file_name) {
        content += `<b>اسم الملف:</b> ${attributes.file_name}<br>`
      }
      if (attributes.point_description) {
        content += `<b>الوصف:</b> ${attributes.point_description}<br>`
      }
      if (attributes.utm_east && attributes.utm_north) {
        content += `<b>UTM:</b> E: ${attributes.utm_east}, N: ${attributes.utm_north}`
        if (attributes.utm_zone) {
          content += ` (${attributes.utm_zone})`
        }
        content += '<br>'
      }
      if (attributes.accuracy !== undefined && attributes.accuracy !== null) {
        content += `<b>الدقة:</b> ${attributes.accuracy}m<br>`
      }

      return content || 'لا توجد معلومات متاحة'
    },
    async loadJxlCoordinates() {
      return this.loadGeodesiaMapLayer('jxlCoordinates')
    },
    cancelGeodesiaLayerRequest(layerKey) {
      const source = this.geodesiaLayerCancels?.[layerKey]
      if (!source) return
      source.cancel('layer-toggled-off')
      this.$delete(this.geodesiaLayerCancels, layerKey)
    },
    cancelAllGeodesiaLayerRequests() {
      Object.keys(this.geodesiaLayerCancels || {}).forEach(key => {
        this.cancelGeodesiaLayerRequest(key)
      })
    },
    notifyGeodesiaLayerTruncated(payload) {
      if (!isGeodesiaLayerTruncated(payload) || !this.$toast?.warning) return
      this.$toast.warning(GEODESIA_LAYER_TRUNCATED_MESSAGE)
    },
    async loadVisibleGeodesiaLayers() {
      const tasks = GEODESIA_MAP_LAYER_KEYS
        .filter(key => this.layerVisibility[key])
        .map(key => this.loadGeodesiaMapLayer(key))
      await Promise.all(tasks)
    },
    getGeodesiaGraphicsLayer(layerKey) {
      const layerMap = {
        vrsCoordinates: this.vrsCoordinatesLayer,
        jxlCoordinates: this.jxlCoordinatesLayer,
        jxlRw5Coordinates: this.jxlRw5CoordinatesLayer,
        jxlRawCoordinates: this.jxlRawCoordinatesLayer,
        jxlPolygons: this.jxlPolygonsLayer,
        jxlBaselineLines: this.jxlBaselineLinesLayer,
      }
      return layerMap[layerKey] || null
    },
    async loadGeodesiaMapLayer(layerKey, { force = false } = {}) {
      if (!GEODESIA_MAP_LAYER_KEYS.includes(layerKey)) return
      if (this.geodesiaLayerLoading[layerKey]) return
      if (!force && this.geodesiaLayerLoaded[layerKey]) return

      const layer = this.getGeodesiaGraphicsLayer(layerKey)
      if (!layer || !this.arcgisModules) return

      this.cancelGeodesiaLayerRequest(layerKey)
      this.$set(this.geodesiaLayerLoading, layerKey, true)

      const cancelSource = createGeodesiaLayerCancelSource()
      this.$set(this.geodesiaLayerCancels, layerKey, cancelSource)

      try {
        const response = await geodesiaApi.getGeodesiaMapLayer(layerKey, {}, { cancelToken: cancelSource.token })
        const payload = unwrapGeodesiaLayerPayload(response)
        const features = getGeodesiaLayerFeatures(payload, layerKey)
        layer.removeAll()

        if (layerKey === 'vrsCoordinates') {
          this.dataStats.vrsCoordinates = features.length
          this.addVrsCoordinatesToMap(features)
        } else if (layerKey === 'jxlPolygons') {
          this.jxlData.polygons = features
          this.dataStats.jxlPolygons = features.length
          this.addJxlPolygonsToMap(features)
        } else if (layerKey === 'jxlBaselineLines') {
          this.jxlData.baselineLines = features
          this.dataStats.jxlBaselineLines = features.length
          this.addJxlBaselineLinesToMap(features)
        } else {
          const sourceKey = GEODESIA_LAYER_SOURCE[layerKey] || 'jxl'
          if (layerKey === 'jxlCoordinates') this.jxlData.points = features
          if (layerKey === 'jxlRw5Coordinates') this.jxlData.rw5Points = features
          if (layerKey === 'jxlRawCoordinates') this.jxlData.rawPoints = features
          this.dataStats[layerKey] = features.length
          this.addSurveyPointsToLayer(layer, features, sourceKey)
        }

        this.notifyGeodesiaLayerTruncated(payload)
        this.$set(this.geodesiaLayerLoaded, layerKey, true)
      } catch (error) {
        if (isGeodesiaLayerRequestCanceled(error)) {
          this.$set(this.geodesiaLayerLoaded, layerKey, false)
          return
        }
        console.error(`Error loading ${layerKey}:`, error)
        this.$set(this.geodesiaLayerLoaded, layerKey, false)
      } finally {
        this.$set(this.geodesiaLayerLoading, layerKey, false)
        if (this.geodesiaLayerCancels[layerKey] === cancelSource) {
          this.$delete(this.geodesiaLayerCancels, layerKey)
        }
      }
    },
    addJxlPolygonsToMap(polygons) {
      if (!this.jxlPolygonsLayer || !this.arcgisModules || !Array.isArray(polygons) || !polygons.length) return
      const {
        Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol,
      } = this.arcgisModules
      polygons.forEach(feature => {
        const rings = feature?.geometry?.coordinates
        if (!Array.isArray(rings) || !Array.isArray(rings[0]) || rings[0].length < 3) return
        const ring = rings[0]
          .filter(coord => Array.isArray(coord) && coord.length >= 2)
          .map(coord => [Number(coord[0]), Number(coord[1])])
        if (ring.length < 3) return
        const color = hexColorToRgb(feature?.attributes?.color, [0, 200, 0])
        this.jxlPolygonsLayer.add(new Graphic({
          geometry: new Polygon({
            rings: [ring],
            spatialReference: { wkid: 4326 },
          }),
          symbol: new SimpleFillSymbol({
            color: [...color, 0.25],
            outline: new SimpleLineSymbol({
              color: [...color, 0.9],
              width: 2,
            }),
          }),
          attributes: feature.attributes || {},
        }))
      })
    },
    isJxlFamilyPointLayer(layer) {
      return !!layer && (
        layer === this.jxlCoordinatesLayer
        || layer === this.jxlRw5CoordinatesLayer
        || layer === this.jxlRawCoordinatesLayer
      )
    },
    getJxlPointSourceKey(point) {
      const raw = (point && (point.source || (point.attributes && point.attributes.source))) || 'jxl'
      const key = String(raw).toLowerCase().trim()
      if (key === 'rw5') return 'rw5'
      if (key === 'raw') return 'raw'
      return 'jxl'
    },
    getLayerForJxlPointSource(sourceKey) {
      if (sourceKey === 'rw5') return this.jxlRw5CoordinatesLayer
      if (sourceKey === 'raw') return this.jxlRawCoordinatesLayer
      return this.jxlCoordinatesLayer
    },
    addJxlCoordinatesToMap(points) {
      this.addSurveyPointsToLayer(this.jxlCoordinatesLayer, points, 'jxl')
    },
    addSurveyPointsToLayer(layer, points, sourceKey = 'jxl') {
      if (!layer || !this.arcgisModules || !Array.isArray(points) || !points.length) {
        return
      }

      const { Point, Graphic, SimpleMarkerSymbol } = this.arcgisModules
      let addedCount = 0

      const markerSymbols = {
        jxl: new SimpleMarkerSymbol({
          style: 'circle',
          color: [0, 200, 0, 0.85],
          size: 8,
          outline: { color: [255, 255, 255, 0.9], width: 2 },
        }),
        rw5: new SimpleMarkerSymbol({
          style: 'circle',
          color: [0, 0, 139, 0.9],
          size: 8,
          outline: { color: [0, 0, 100, 0.85], width: 2 },
        }),
        raw: new SimpleMarkerSymbol({
          style: 'circle',
          color: [255, 215, 0, 0.9],
          size: 8,
          outline: { color: [255, 255, 255, 0.9], width: 2 },
        }),
      }

      const markerSymbol = markerSymbols[sourceKey] || markerSymbols.jxl

      points.forEach(point => {
        try {
          const coordinates = point.geometry && point.geometry.coordinates
          if (!coordinates || coordinates.length < 2) {
            return
          }

          const [longitude, latitude] = coordinates

          if (!longitude || !latitude || isNaN(longitude) || isNaN(latitude)) {
            return
          }

          const pointGeometry = new Point({
            longitude,
            latitude,
            spatialReference: { wkid: 4326 },
          })

          const attributes = { ...(point.attributes || {}), source: sourceKey }
          const popupContent = this.buildJxlCoordinatePopupContent(attributes)

          const graphic = new Graphic({
            geometry: pointGeometry,
            symbol: markerSymbol,
            attributes,
            popupTemplate: {
              title: attributes.point_name || `JXL Point ${attributes.id || ''}`,
              content: popupContent,
            },
          })

          layer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding survey coordinate to map:', error, point)
        }
      })

      console.log(`Added ${addedCount} ${String(sourceKey).toUpperCase()} coordinates to map out of ${points.length}`)
    },
    addJxlBaselineLinesToMap(lines) {
      if (!this.jxlBaselineLinesLayer || !this.arcgisModules || !lines.length) {
        return
      }

      const { Polyline, Graphic, SimpleLineSymbol } = this.arcgisModules
      let addedCount = 0

      lines.forEach(feature => {
        try {
          const geom = feature.geometry
          if (!geom || geom.type !== 'LineString' || !Array.isArray(geom.coordinates) || geom.coordinates.length < 2) {
            return
          }

          const coords = geom.coordinates.map(c => {
            if (!Array.isArray(c) || c.length < 2) return null
            return [Number(c[0]), Number(c[1])]
          }).filter(Boolean)

          if (coords.length < 2) {
            return
          }

          const lineGeometry = new Polyline({
            paths: [coords],
            spatialReference: { wkid: 4326 },
          })

          const attributes = { ...(feature.properties || {}), ...(feature.attributes || {}) }
          const colorHex = attributes.color || '#0078D7'
          const lineColor = this.hexToRgb(colorHex)
          const symbol = new SimpleLineSymbol({
            color: lineColor,
            width: 2,
            cap: 'round',
            join: 'round',
          })

          const fromName = attributes.from_point_name || ''
          const toName = attributes.to_point_name || ''
          const title = fromName && toName ? `${fromName} → ${toName}` : 'خط الأساس'

          const graphic = new Graphic({
            geometry: lineGeometry,
            symbol,
            attributes,
            popupTemplate: {
              title,
              content: this.buildJxlBaselineLinePopupContent(attributes),
            },
          })

          this.jxlBaselineLinesLayer.add(graphic)
          addedCount++
        } catch (error) {
          console.error('Error adding JXL baseline line to map:', error, feature)
        }
      })

      console.log(`Added ${addedCount} JXL baseline lines to map out of ${lines.length}`)
    },
    buildJxlBaselineLinePopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = ''
      if (attributes.from_point_name) {
        content += `<b>من:</b> ${attributes.from_point_name}<br>`
      }
      if (attributes.to_point_name) {
        content += `<b>إلى:</b> ${attributes.to_point_name}<br>`
      }
      if (attributes.file_name) {
        content += `<b>اسم الملف:</b> ${attributes.file_name}<br>`
      }
      if (attributes.jxl_file_id) {
        content += `<b>معرف ملف JXL:</b> ${attributes.jxl_file_id}<br>`
      }
      if (attributes.project_name) {
        content += `<b>اسم المشروع:</b> ${attributes.project_name}<br>`
      }
      if (attributes.is_assigned !== undefined && attributes.is_assigned !== null) {
        content += `<b>معيّن:</b> ${attributes.is_assigned ? 'نعم' : 'لا'}<br>`
      }

      return content || 'لا توجد معلومات متاحة'
    },
    buildJxlCoordinatePopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = ''
      if (attributes.source) {
        const src = String(attributes.source).toLowerCase()
        const srcLabel = src === 'rw5' ? 'RW5' : src === 'raw' ? 'RAW' : 'JXL'
        content += `<b>المصدر:</b> ${srcLabel}<br>`
      }
      if (attributes.id) {
        content += `<b>ID:</b> ${attributes.id}<br>`
      }
      if (attributes.point_name) {
        content += `<b>اسم النقطة:</b> ${attributes.point_name}<br>`
      }
      if (attributes.latitude !== undefined && attributes.latitude !== null) {
        content += `<b>خط العرض:</b> ${parseFloat(attributes.latitude).toFixed(8)}<br>`
      }
      if (attributes.longitude !== undefined && attributes.longitude !== null) {
        content += `<b>خط الطول:</b> ${parseFloat(attributes.longitude).toFixed(8)}<br>`
      }
      if (attributes.elevation !== undefined && attributes.elevation !== null) {
        content += `<b>الارتفاع:</b> ${attributes.elevation}m<br>`
      }
      if (attributes.file_name) {
        content += `<b>اسم الملف:</b> ${attributes.file_name}<br>`
      }
      if (attributes.point_description) {
        content += `<b>الوصف:</b> ${attributes.point_description}<br>`
      }
      if (attributes.utm_east && attributes.utm_north) {
        content += `<b>UTM:</b> E: ${attributes.utm_east}, N: ${attributes.utm_north}`
        if (attributes.utm_zone) {
          content += ` (${attributes.utm_zone})`
        }
        content += '<br>'
      }
      if (attributes.accuracy !== undefined && attributes.accuracy !== null) {
        content += `<b>الدقة:</b> ${attributes.accuracy}m<br>`
      }
      if (attributes.project_id) {
        content += `<b>معرف المشروع:</b> ${attributes.project_id}<br>`
      }
      if (attributes.project_name) {
        content += `<b>اسم المشروع:</b> ${attributes.project_name}<br>`
      }

      return content || 'لا توجد معلومات متاحة'
    },
    buildJxlPointPopupWithPolygon(pointAttributes) {
      if (!pointAttributes) return 'لا توجد معلومات متاحة'

      // Build point info
      let content = '<div style="padding: 10px;"><h5>معلومات النقطة</h5>'
      content += this.buildJxlCoordinatePopupContent(pointAttributes)

      // Find and add polygon info
      if (pointAttributes.jxl_file_id) {
        const polygon = this.jxlData.polygons.find(p => p.attributes && p.attributes.jxl_file_id === pointAttributes.jxl_file_id)

        if (polygon && polygon.attributes) {
          content += '<hr style="margin: 15px 0;"><h5>معلومات المضلع</h5>'
          content += this.buildJxlPolygonPopupContent(polygon.attributes)
        }
      }

      content += '</div>'
      return content
    },
    showJxlPolygon(jxlFileId) {
      if (!this.jxlPolygonsLayer || !this.arcgisModules || !this.view) {
        return
      }

      // Find polygon for this JXL file
      const polygon = this.jxlData.polygons.find(p => p.attributes && p.attributes.jxl_file_id === jxlFileId)

      if (!polygon) {
        console.warn('Polygon not found for JXL file ID:', jxlFileId)
        return
      }

      // Remove previous polygon if exists
      if (this.currentPolygonGraphic) {
        this.jxlPolygonsLayer.remove(this.currentPolygonGraphic)
        this.currentPolygonGraphic = null
      }

      try {
        const {
          Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol, Extent,
        } = this.arcgisModules

        // Get coordinates from polygon geometry
        const { coordinates } = polygon.geometry
        if (!coordinates || !coordinates[0] || !coordinates[0].length) {
          console.warn('Invalid polygon geometry:', polygon)
          return
        }

        // Convert GeoJSON coordinates to ArcGIS rings format
        const rings = coordinates[0].map(coord =>
          // GeoJSON is [lng, lat], ArcGIS expects [lng, lat]
          [coord[0], coord[1]])

        // Create polygon geometry
        const polygonGeometry = new Polygon({
          rings: [rings],
          spatialReference: { wkid: 4326 },
        })

        // Create symbol
        const symbol = new SimpleFillSymbol({
          color: [0, 200, 0, 0.3], // Green with transparency
          outline: new SimpleLineSymbol({
            color: [0, 200, 0],
            width: 2,
          }),
        })

        // Build popup content
        const attributes = polygon.attributes || {}
        const popupContent = this.buildJxlPolygonPopupContent(attributes)

        // Create graphic
        const graphic = new Graphic({
          geometry: polygonGeometry,
          symbol,
          attributes,
          popupTemplate: {
            title: `مضلع JXL: ${attributes.file_name || 'N/A'}`,
            content: popupContent,
          },
        })

        // Add to layer
        this.jxlPolygonsLayer.add(graphic)
        this.currentPolygonGraphic = graphic

        // Fit map to polygon
        this.view.when().then(() => {
          const extent = new Extent({
            xmin: Math.min(...rings.map(r => r[0])),
            ymin: Math.min(...rings.map(r => r[1])),
            xmax: Math.max(...rings.map(r => r[0])),
            ymax: Math.max(...rings.map(r => r[1])),
            spatialReference: { wkid: 4326 },
          })

          this.view.goTo(extent, {
            padding: 50,
            animate: false,
          }).catch(err => {
            console.warn('Error fitting view to polygon:', err)
          })
        })
      } catch (error) {
        console.error('Error displaying JXL polygon:', error)
      }
    },
    buildJxlPolygonPopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = ''
      if (attributes.jxl_file_id) {
        content += `<b>معرف ملف JXL:</b> ${attributes.jxl_file_id}<br>`
      }
      if (attributes.file_name) {
        content += `<b>اسم الملف:</b> ${attributes.file_name}<br>`
      }
      if (attributes.points_count !== undefined && attributes.points_count !== null) {
        content += `<b>عدد النقاط:</b> ${attributes.points_count}<br>`
      }
      if (attributes.project_id) {
        content += `<b>معرف المشروع:</b> ${attributes.project_id}<br>`
      }
      if (attributes.project_name) {
        content += `<b>اسم المشروع:</b> ${attributes.project_name}<br>`
      }
      if (attributes.status) {
        content += `<b>الحالة:</b> ${attributes.status}<br>`
      }
      if (attributes.assigned_at) {
        content += `<b>تاريخ التعيين:</b> ${attributes.assigned_at}<br>`
      }

      return content || 'لا توجد معلومات متاحة'
    },
    async addUserLocation() {
      if (this.locationLoading) return
      this.locationLoading = true
      this.setHomeButtonLoading(true)

      try {
        const location = await this.getUserCurrentLocation()

        if (!this.userLocationLayer || !this.arcgisModules) return

        const { Point, Graphic, SimpleMarkerSymbol } = this.arcgisModules

        // Clear existing user location
        this.userLocationLayer.removeAll()

        // Create point geometry
        const point = new Point({
          longitude: location.longitude,
          latitude: location.latitude,
          spatialReference: { wkid: 4326 },
        })

        // Create symbol - blue point for current location
        const symbol = new SimpleMarkerSymbol({
          style: 'circle',
          color: [0, 0, 255], // Blue
          size: 12,
          outline: {
            color: [255, 255, 255],
            width: 2,
          },
        })

        // Create graphic
        const graphic = new Graphic({
          geometry: point,
          symbol,
          attributes: {
            id: 'user_location',
            name: 'موقعي الحالي',
          },
          popupTemplate: {
            title: 'موقعي الحالي',
            content: `
              <b>خط العرض:</b> ${location.latitude.toFixed(6)}<br>
              <b>خط الطول:</b> ${location.longitude.toFixed(6)}<br>
              <b>الدقة:</b> ${location.accuracy ? location.accuracy.toFixed(2) : 'N/A'} متر
            `,
          },
        })

        this.userLocationLayer.add(graphic)

        // Center map on user location
        if (this.view) {
          try {
            // Ensure view is ready
            await this.view.when()
            await this.view.goTo({
              center: [location.longitude, location.latitude],
              zoom: 15,
            }, {
              animate: false, // Disable animation to avoid animation errors
            })
          } catch (err) {
            console.warn('Error navigating to user location:', err)
            // Fallback: set center directly without animation
            try {
              this.view.center = [location.longitude, location.latitude]
              this.view.zoom = 15
            } catch (fallbackErr) {
              console.error('Error setting view center directly:', fallbackErr)
            }
          }
        }
      } catch (error) {
        console.error('Error getting user location:', error)
        if (this.$toast && this.$toast.error) {
          this.$toast.error('فشل في الحصول على موقعك')
        }
      } finally {
        this.locationLoading = false
        this.setHomeButtonLoading(false)
      }
    },
    setHomeButtonLoading(isLoading) {
      if (!this.homeButton) return

      if (isLoading) {
        this.homeButton.classList.add('home-location-button--loading')
        this.homeButton.innerHTML = '<span class="home-location-spinner"></span>'
      } else {
        this.homeButton.classList.remove('home-location-button--loading')
        this.homeButton.innerHTML = '<span class="esri-icon-home"></span>'
      }
    },
    getUserCurrentLocation() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('Geolocation is not supported by your browser'))
          return
        }

        navigator.geolocation.getCurrentPosition(
          position => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              accuracy: position.coords.accuracy,
            })
          },
          error => {
            reject(error)
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          },
        )
      })
    },
    async zoomToExtent() {
      if (!this.view || !this.arcgisModules) return

      try {
        const { Extent } = this.arcgisModules
        const allGraphics = [
          ...this.projectsLayer.graphics.toArray(),
          ...this.mapLibrariesLayer.graphics.toArray(),
          ...this.fixedPointsLayer.graphics.toArray(),
          ...this.vrsCoordinatesLayer.graphics.toArray(),
          ...this.jxlCoordinatesLayer.graphics.toArray(),
          ...this.jxlRw5CoordinatesLayer.graphics.toArray(),
          ...this.jxlRawCoordinatesLayer.graphics.toArray(),
          ...this.jxlPolygonsLayer.graphics.toArray(),
          ...(this.jxlBaselineLinesLayer ? this.jxlBaselineLinesLayer.graphics.toArray() : []),
        ]

        if (allGraphics.length === 0) return

        // Get all geometries
        const geometries = allGraphics
          .map(g => g.geometry)
          .filter(g => g !== null && g !== undefined)

        if (geometries.length === 0) return

        // Calculate extent from all geometries
        let minX = Infinity
        let minY = Infinity
        let maxX = -Infinity
        let maxY = -Infinity

        geometries.forEach(geometry => {
          if (geometry.type === 'point') {
            minX = Math.min(minX, geometry.longitude)
            maxX = Math.max(maxX, geometry.longitude)
            minY = Math.min(minY, geometry.latitude)
            maxY = Math.max(maxY, geometry.latitude)
          } else if (geometry.type === 'polygon') {
            geometry.rings.forEach(ring => {
              ring.forEach(coord => {
                minX = Math.min(minX, coord[0])
                maxX = Math.max(maxX, coord[0])
                minY = Math.min(minY, coord[1])
                maxY = Math.max(maxY, coord[1])
              })
            })
          } else if (geometry.type === 'polyline') {
            geometry.paths.forEach(path => {
              path.forEach(coord => {
                minX = Math.min(minX, coord[0])
                maxX = Math.max(maxX, coord[0])
                minY = Math.min(minY, coord[1])
                maxY = Math.max(maxY, coord[1])
              })
            })
          }
        })

        if (minX === Infinity) return

        // Add padding
        const padding = 0.1
        const width = maxX - minX
        const height = maxY - minY
        const xPadding = width * padding
        const yPadding = height * padding

        const extent = new Extent({
          xmin: minX - xPadding,
          ymin: minY - yPadding,
          xmax: maxX + xPadding,
          ymax: maxY + yPadding,
          spatialReference: { wkid: 4326 },
        })

        try {
          // Ensure view is ready
          await this.view.when()
          await this.view.goTo(extent, {
            animate: false, // Disable animation to avoid animation errors
          })
        } catch (err) {
          console.warn('Error navigating to extent:', err)
          // Fallback: set extent directly without animation
          try {
            this.view.extent = extent
          } catch (fallbackErr) {
            console.error('Error setting view extent directly:', fallbackErr)
          }
        }
      } catch (error) {
        console.error('Error zooming to extent:', error)
      }
    },
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result
        ? [
          parseInt(result[1], 16),
          parseInt(result[2], 16),
          parseInt(result[3], 16),
          0.9,
        ]
        : [0, 153, 255, 0.9]
    },
    createPinIcon(colorHex) {
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
          <ellipse cx="16" cy="36" rx="4" ry="2" fill="rgba(0,0,0,0.2)"/>
          <path d="M16 2C10.477 2 6 6.477 6 12c0 6 10 24 10 24s10-18 10-24C26 6.477 21.523 2 16 2z" 
                fill="${colorHex}" 
                stroke="#ffffff" 
                stroke-width="2"/>
          <circle cx="16" cy="12" r="5" fill="#ffffff"/>
          <circle cx="16" cy="12" r="3" fill="${colorHex}"/>
        </svg>
      `.trim()
      return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`
    },
    buildProjectPopupContent(attributes) {
      if (attributes) {
        return `
          <b>معرف المشروع:</b> ${attributes.id || 'N/A'}<br>
          <b>الاسم:</b> ${attributes.name || 'N/A'}<br>
          <b>تم الربط بملفات JXL:</b> ${attributes.is_jxl_files ? 'نعم' : 'لا'}<br>
          <b>المالك:</b> ${attributes.owner_name || 'N/A'}<br>
          <b>الحالة:</b> ${attributes.status || 'N/A'}<br>
          <b>الكود المساحي:</b> <a href="https://alhalwany-esga.com/project-details/${attributes.id}" target="_blank" rel="noopener noreferrer">${attributes.surveying_code || 'N/A'}</a>
        `
      }
      return 'لا توجد معلومات متاحة'
    },
    buildMapLibraryPopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = '<b>مكتبة خرائط</b><br>'
      if (attributes.governorate) {
        content += `<b>المحافظة:</b> ${attributes.governorate.name_ar || attributes.governorate.name || 'N/A'}<br>`
      }
      if (attributes.center) {
        content += `<b>المركز:</b> ${attributes.center.name_ar || attributes.center.name || 'N/A'}<br>`
      }
      if (attributes.city) {
        content += `<b>المدينة:</b> ${attributes.city.name_ar || attributes.city.name || 'N/A'}<br>`
      }
      if (attributes.district) {
        content += `<b>الحي:</b> ${attributes.district.name_ar || attributes.district.name || 'N/A'}<br>`
      }
      if (attributes.shape_area) {
        content += `<b>المساحة:</b> ${attributes.shape_area}<br>`
      }

      return content
    },
    buildFixedPointPopupContent(attributes) {
      if (!attributes) return 'لا توجد معلومات متاحة'

      let content = ''
      if (attributes.code) {
        content += `<b>الكود:</b> ${attributes.code}<br>`
      }
      if (attributes.level !== undefined && attributes.level !== null) {
        content += `<b>المستوى:</b> ${attributes.level}<br>`
      }
      if (attributes.accuracy_degree_label_ar || attributes.accuracy_degree_label) {
        content += `<b>درجة الدقة:</b> ${attributes.accuracy_degree_label_ar || attributes.accuracy_degree_label || 'N/A'}<br>`
      }
      if (attributes.description) {
        content += `<b>الوصف:</b> ${attributes.description}<br>`
      }
      if (attributes.corrected_latitude && attributes.corrected_longitude) {
        content += `<b>الإحداثيات:</b> ${parseFloat(attributes.corrected_latitude).toFixed(6)}, ${parseFloat(attributes.corrected_longitude).toFixed(6)}<br>`
      } else if (attributes.latitude && attributes.longitude) {
        content += `<b>الإحداثيات:</b> ${parseFloat(attributes.latitude).toFixed(6)}, ${parseFloat(attributes.longitude).toFixed(6)}<br>`
      }
      if (attributes.governorate) {
        content += `<b>المحافظة:</b> ${attributes.governorate.name_ar || attributes.governorate.name || 'N/A'}<br>`
      }
      if (attributes.city) {
        content += `<b>المدينة:</b> ${attributes.city.name_ar || attributes.city.name || 'N/A'}<br>`
      }

      return content || 'لا توجد معلومات متاحة'
    },
    parseSurveyCodings() {
      // Parse survey codings from text - support both newline and comma separation
      const text = this.assignSurveyCodingsText.trim()
      if (!text) {
        this.assignSurveyCodings = []
        return
      }

      // Split by newlines first, then by commas, then filter empty strings
      const codings = text
        .split(/[\n,،]/) // Split by newline, comma, or Arabic comma
        .map(code => code.trim())
        .filter(code => code.length > 0)

      this.assignSurveyCodings = codings
    },
    selectAllCoordinates() {
      if (this.assignJxlResult && this.assignJxlResult.jxl_points) {
        this.selectedCoordinateIds = this.assignJxlResult.jxl_points.map(point => point.id).filter(id => id !== null && id !== undefined)
      }
    },
    async handleAssignJxl() {
      // Parse codings before validation
      this.parseSurveyCodings()

      // Determine which coordinate IDs to use
      const coordinateIdsToUse = this.selectedCoordinateIds.length > 0
        ? this.selectedCoordinateIds
        : (this.assignJxlCoordinateId ? [this.assignJxlCoordinateId] : [])

      if (this.assignSurveyCodings.length === 0 || coordinateIdsToUse.length === 0) {
        if (this.$toast && this.$toast.error) {
          this.$toast.error('يرجى إدخال أكواد الرفع المساحي واختيار إحداثي واحد على الأقل')
        }
        return
      }

      // Check if API method exists
      if (!geodesiaApi || typeof geodesiaApi.assignJxlToProjectBySurveyCoding !== 'function') {
        console.error('geodesiaApi.assignJxlToProjectBySurveyCoding is not available')
        if (this.$toast && this.$toast.error) {
          this.$toast.error('خطأ في تحميل واجهة برمجة التطبيقات. يرجى تحديث الصفحة')
        }
        return
      }

      this.assigningJxl = true
      this.assignJxlError = null
      this.assignJxlResult = null

      try {
        // Call API for each selected coordinate ID
        const results = []
        for (const coordinateId of coordinateIdsToUse) {
          const response = await geodesiaApi.assignJxlToProjectBySurveyCoding(
            this.assignSurveyCodings,
            null, // jxlFileId - not used
            coordinateId,
          )

          if (response.success) {
            results.push(response.data)
            // Fetch updated map data and update project polygons without refreshing the map
            await this.updateProjectsFromMapData()
          } else {
            // If one fails, continue with others but log the error
            console.error(`Failed to assign coordinate ${coordinateId}:`, response.message)
          }
          this.assignJxlCoordinateId = null
        }

        // Use the last result (or combine results if needed)
        if (results.length > 0) {
          // For now, use the last result. You can modify this to combine results if needed
          this.assignJxlResult = results[results.length - 1]
          this.activeTabIndex = 0 // Reset to first tab

          // If multiple coordinates were assigned, merge the related_projects
          if (results.length > 1) {
            const allRelatedProjects = []
            results.forEach(result => {
              if (result.related_projects && Array.isArray(result.related_projects)) {
                allRelatedProjects.push(...result.related_projects)
              }
            })
            // Remove duplicates based on project id
            const uniqueProjects = allRelatedProjects.filter((project, index, self) => index === self.findIndex(p => p.id === project.id))
            this.assignJxlResult.related_projects = uniqueProjects
          }

          // Load coordinates for the first project tab
          if (this.assignJxlResult.related_projects && this.assignJxlResult.related_projects.length > 0) {
            await this.onTabChange(0)
          }

          // Show appropriate toast message
          if (this.$toast && this.$toast.success) {
            const assignedCount = this.assignJxlResult.assigned_projects_count || 0
            const skippedCount = this.assignJxlResult.skipped_projects_count || 0

            if (assignedCount > 0 && skippedCount === 0) {
              this.$toast.success(`تم ربط ${coordinateIdsToUse.length} إحداثي بـ ${assignedCount} مشروع بنجاح`)
            } else if (assignedCount > 0 && skippedCount > 0) {
              this.$toast.success(`تم ربط ${coordinateIdsToUse.length} إحداثي بـ ${assignedCount} مشروع، وتم تجاهل ${skippedCount} مشروع`)
            } else if (assignedCount === 0 && skippedCount > 0) {
              this.$toast.warning(`تم تجاهل جميع المشاريع (${skippedCount}) - قد تكون مربوطة بالفعل`)
            } else {
              this.$toast.success(`تمت العملية لـ ${coordinateIdsToUse.length} إحداثي`)
            }
          }

          // Refresh map data to show updated project associations
          // await this.loadMapData();
          // Clear form after successful assignment (longer timeout to read results)
          // setTimeout(() => {
          //   this.resetAssignJxl();
          // }, 8000);
        } else {
          this.assignJxlError = 'فشل ربط جميع الإحداثيات'
          if (this.$toast && this.$toast.error) {
            this.$toast.error(this.assignJxlError)
          }
        }
      } catch (err) {
        console.error('Error assigning JXL file:', err)
        const errorData = err.response && err.response.data ? err.response.data : err.response

        let errorMessage = 'حدث خطأ أثناء ربط الملف بالمشاريع'

        if (errorData) {
          if (errorData.errors) {
            // Handle validation errors
            const errorKeys = Object.keys(errorData.errors)
            if (errorKeys.length > 0) {
              const firstError = errorData.errors[errorKeys[0]]
              errorMessage = Array.isArray(firstError)
                ? firstError[0]
                : firstError
            }
          } else if (errorData.message) {
            errorMessage = errorData.message
          }
        }

        this.assignJxlError = errorMessage
        if (this.$toast && this.$toast.error) {
          this.$toast.error(errorMessage)
        }
      } finally {
        this.assigningJxl = false
      }
    },
    async handleUnAssignJxl() {
      this.parseSurveyCodings()

      const codingsToUnassign = [...new Set(
        this.assignSurveyCodings.map(c => String(c).trim()).filter(Boolean),
      )]
      if (codingsToUnassign.length === 0) {
        if (this.$toast && this.$toast.error) {
          this.$toast.error('لا يوجد كود رفع مساحي لإلغاء الربط')
        }
        return
      }

      if (!geodesiaApi || typeof geodesiaApi.unAssignJxlToProjectBySurveyCoding !== 'function') {
        console.error('geodesiaApi.unAssignJxlToProjectBySurveyCoding is not available')
        if (this.$toast && this.$toast.error) {
          this.$toast.error('خطأ في تحميل واجهة برمجة التطبيقات. يرجى تحديث الصفحة')
        }
        return
      }

      this.unAssigningJxl = true
      this.assignJxlError = null

      try {
        for (let i = 0; i < codingsToUnassign.length; i += 1) {
          const surveyCoding = codingsToUnassign[i]
          const response = await geodesiaApi.unAssignJxlToProjectBySurveyCoding(surveyCoding)
          if (!response.success) {
            throw new Error(response.message || `فشل إلغاء الربط للكود ${surveyCoding}`)
          }
        }

        if (this.$toast && this.$toast.success) {
          this.$toast.success('تم إلغاء الربط بنجاح')
        }
        this.assignJxlResult = null
        this.selectedCoordinateIds = []
        this.activeTabIndex = 0
        await this.updateProjectsFromMapData()
      } catch (err) {
        console.error('Error unassigning JXL:', err)
        const errorData = err.response && err.response.data ? err.response.data : err.response
        let errorMessage = err.message || 'حدث خطأ أثناء إلغاء الربط'

        if (errorData) {
          if (errorData.errors) {
            const errorKeys = Object.keys(errorData.errors)
            if (errorKeys.length > 0) {
              const firstError = errorData.errors[errorKeys[0]]
              errorMessage = Array.isArray(firstError) ? firstError[0] : firstError
            }
          } else if (errorData.message) {
            errorMessage = errorData.message
          }
        }

        this.assignJxlError = errorMessage
        if (this.$toast && this.$toast.error) {
          this.$toast.error(errorMessage)
        }
      } finally {
        this.unAssigningJxl = false
      }
    },
    resetAssignJxl() {
      this.assignSurveyCodingsText = ''
      this.assignSurveyCodings = []
      this.assignJxlCoordinateId = null
      this.selectedCoordinateIds = []
      this.assignJxlError = null
      this.assigningJxl = false
      this.unAssigningJxl = false
    },
    resetAllForm() {
      // Reset all form fields and state
      this.assignSurveyCodingsText = ''
      this.assignSurveyCodings = []
      this.assignJxlCoordinateId = null
      this.selectedCoordinateIds = []
      this.assignJxlError = null
      this.assignJxlResult = null
      this.assigningJxl = false
      this.unAssigningJxl = false
      this.assigningCoordinates = false
      this.activeTabIndex = 0
      this.loadingCoordinates = false
      this.searchSurveyingCode = ''
      this.searchProjectError = null
      this.searchProjectSuccess = null
      this.searchingProject = false

      if (this.$toast && this.$toast.success) {
        this.$toast.success('تم إعادة تعيين النموذج')
      }
    },
    clearSearchMessages() {
      this.searchProjectError = null
      this.searchProjectSuccess = null
    },
    async navigateToProjectByCode() {
      if (!this.searchSurveyingCode || !this.searchSurveyingCode.trim()) {
        this.searchProjectError = 'يرجى إدخال الكود المساحي'
        this.searchProjectSuccess = null
        return
      }

      if (!this.projectsLayer || !this.view || !this.arcgisModules) {
        this.searchProjectError = 'الخريطة غير جاهزة بعد'
        this.searchProjectSuccess = null
        return
      }

      this.searchingProject = true
      this.searchProjectError = null
      this.searchProjectSuccess = null

      try {
        // Get all graphics from projects layer
        const graphics = this.projectsLayer.graphics.toArray()

        // Find project with matching surveying_code
        const projectGraphic = graphics.find(graphic => {
          const attributes = graphic.attributes || {}
          const surveyingCode = attributes.surveying_code || attributes.survey_coding || ''
          return surveyingCode.toString().trim().toLowerCase() === this.searchSurveyingCode.trim().toLowerCase()
        })

        if (!projectGraphic) {
          this.searchProjectError = `لم يتم العثور على مشروع بالكود المساحي: ${this.searchSurveyingCode}`
          if (this.$toast && this.$toast.error) {
            this.$toast.error(this.searchProjectError)
          }
          return
        }

        // Get project geometry
        const { geometry } = projectGraphic
        if (!geometry) {
          this.searchProjectError = 'المشروع لا يحتوي على إحداثيات'
          if (this.$toast && this.$toast.error) {
            this.$toast.error(this.searchProjectError)
          }
          return
        }

        // Navigate to project
        await this.view.when()

        // Calculate extent for polygon or center for point
        let targetExtent = null
        let targetCenter = null
        const targetZoom = 15

        if (geometry.type === 'polygon' && geometry.rings && geometry.rings.length > 0) {
          // Calculate extent from polygon rings
          const { Extent } = this.arcgisModules
          let minX = Infinity
          let minY = Infinity
          let maxX = -Infinity
          let maxY = -Infinity

          geometry.rings.forEach(ring => {
            ring.forEach(coord => {
              minX = Math.min(minX, coord[0])
              maxX = Math.max(maxX, coord[0])
              minY = Math.min(minY, coord[1])
              maxY = Math.max(maxY, coord[1])
            })
          })

          if (minX !== Infinity) {
            // Add padding
            const padding = 0.05
            const width = maxX - minX
            const height = maxY - minY
            const xPadding = width * padding
            const yPadding = height * padding

            targetExtent = new Extent({
              xmin: minX - xPadding,
              ymin: minY - yPadding,
              xmax: maxX + xPadding,
              ymax: maxY + yPadding,
              spatialReference: { wkid: 4326 },
            })
          }
        } else if (geometry.type === 'point') {
          targetCenter = [geometry.longitude, geometry.latitude]
        }

        // Navigate to the project
        if (targetExtent) {
          await this.view.goTo(targetExtent, {
            animate: true,
            duration: 1000,
          })
        } else if (targetCenter) {
          await this.view.goTo({
            center: targetCenter,
            zoom: targetZoom,
          }, {
            animate: true,
            duration: 1000,
          })
        } else {
          // Fallback: use geometry directly
          await this.view.goTo(geometry, {
            animate: true,
            duration: 1000,
          })
        }

        // Highlight the project by opening its popup
        const attributes = projectGraphic.attributes || {}
        const projectName = attributes.name || attributes.surveying_code || 'مشروع'

        // Calculate center point for popup
        let popupLocation = null
        if (geometry.type === 'polygon' && geometry.rings && geometry.rings.length > 0) {
          // Calculate centroid from polygon rings
          let sumX = 0
          let sumY = 0
          let count = 0
          geometry.rings[0].forEach(coord => {
            sumX += coord[0]
            sumY += coord[1]
            count++
          })
          if (count > 0) {
            const { Point } = this.arcgisModules
            popupLocation = new Point({
              longitude: sumX / count,
              latitude: sumY / count,
              spatialReference: { wkid: 4326 },
            })
          }
        } else if (geometry.type === 'point') {
          popupLocation = geometry
        }

        // Open popup at the project location
        if (popupLocation) {
          this.view.openPopup({
            location: popupLocation,
            features: [projectGraphic],
            popupEnabled: true,
          })
        }

        this.searchProjectSuccess = `تم العثور على المشروع: ${projectName}`
        if (this.$toast && this.$toast.success) {
          this.$toast.success(this.searchProjectSuccess)
        }
      } catch (error) {
        console.error('Error navigating to project:', error)
        this.searchProjectError = 'حدث خطأ أثناء البحث عن المشروع'
        if (this.$toast && this.$toast.error) {
          this.$toast.error(this.searchProjectError)
        }
      } finally {
        this.searchingProject = false
      }
    },
    async handleAssignCoordinatesToProject(projectId) {
      if (!projectId || this.selectedCoordinateIds.length === 0) {
        if (this.$toast && this.$toast.error) {
          this.$toast.error('يرجى اختيار إحداثي واحد على الأقل')
        }
        return
      }

      // Check if API method exists
      if (!geodesiaApi || typeof geodesiaApi.assignJxlCoordinatesToProject !== 'function') {
        console.error('geodesiaApi.assignJxlCoordinatesToProject is not available')
        if (this.$toast && this.$toast.error) {
          this.$toast.error('خطأ في تحميل واجهة برمجة التطبيقات. يرجى تحديث الصفحة')
        }
        return
      }

      this.assigningCoordinates = true
      this.assignJxlError = null

      try {
        const response = await geodesiaApi.assignJxlCoordinatesToProject(
          projectId,
          this.selectedCoordinateIds,
        )

        if (response.success) {
          if (this.$toast && this.$toast.success) {
            this.$toast.success(`تم ربط ${this.selectedCoordinateIds.length} إحداثي بالمشروع بنجاح`)
          }
          // Refresh map data to show updated project associations
          await this.loadMapData()
          // Reload coordinates for the current project to reflect changes
          if (this.assignJxlResult && this.assignJxlResult.related_projects) {
            const currentProject = this.assignJxlResult.related_projects[this.activeTabIndex]
            if (currentProject && currentProject.id) {
              await this.onTabChange(this.activeTabIndex)
            }
          }
        } else {
          this.assignJxlError = response.message || 'فشل ربط الإحداثيات بالمشروع'
          if (this.$toast && this.$toast.error) {
            this.$toast.error(this.assignJxlError)
          }
        }
      } catch (err) {
        console.error('Error assigning coordinates to project:', err)
        const errorData = err.response && err.response.data ? err.response.data : err.response

        let errorMessage = 'حدث خطأ أثناء ربط الإحداثيات بالمشروع'

        if (errorData) {
          if (errorData.errors) {
            // Handle validation errors
            const errorKeys = Object.keys(errorData.errors)
            if (errorKeys.length > 0) {
              const firstError = errorData.errors[errorKeys[0]]
              errorMessage = Array.isArray(firstError)
                ? firstError[0]
                : firstError
            }
          } else if (errorData.message) {
            errorMessage = errorData.message
          }
        }

        this.assignJxlError = errorMessage
        if (this.$toast && this.$toast.error) {
          this.$toast.error(errorMessage)
        }
      } finally {
        this.assigningCoordinates = false
      }
    },
    async onTabChange(tabIndex) {
      if (!this.assignJxlResult || !this.assignJxlResult.related_projects) {
        return
      }

      const project = this.assignJxlResult.related_projects[tabIndex]
      if (!project || !project.id) {
        return
      }

      // Set searchSurveyingCode to the project's survey coding and navigate to it
      if (project.survey_coding || project.surveying_code) {
        this.searchSurveyingCode = project.survey_coding || project.surveying_code
        // Clear any previous error messages
        this.searchProjectError = null
        this.searchProjectSuccess = null
        // Navigate to the project on the map
        await this.navigateToProjectByCode()
      }

      this.loadingCoordinates = true
      this.selectedCoordinateIds = []

      try {
        const response = await geodesiaApi.getJxlCoordinatesByProjectId(project.id)

        if (response.success && response.data && response.data.coordinates_ids) {
          // Update selected coordinates with the IDs from the API
          this.selectedCoordinateIds = response.data.coordinates_ids.map(id => Number(id))
        } else {
          // If no coordinates found, clear selection
          this.selectedCoordinateIds = []
        }
      } catch (err) {
        console.error('Error fetching coordinates for project:', err)
        // On error, clear selection
        this.selectedCoordinateIds = []
      } finally {
        this.loadingCoordinates = false
      }
    },
  },
}
</script>

<style scoped>
.geodesia-lab {
  padding: 1rem;
  height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
}

.geodesia-lab >>> .row {
  height: 100%;
  margin: 0;
}

.geodesia-lab >>> .col {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.map-container-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  flex: 1;
  min-height: 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.map-view {
  width: 100%;
  height: 100%;
}

.home-location-button {
  margin-top: 4px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.skipped-project-item {
  background-color: #fff3cd;
  border-color: #ffc107 !important;
}

.max-height-200 {
  max-height: 200px;
  overflow-y: auto;
}
</style>

<style>
.home-location-button--loading {
  pointer-events: none;
  opacity: 0.8;
}

.home-location-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #3498db;
  border-top-color: transparent;
  border-radius: 50%;
  box-sizing: border-box;
  animation: home-location-spin 1s linear infinite;
}

@keyframes home-location-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
